
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import TermsAndPolicy from "./pages/TermsAndPolicy";
import ProfessionalPage from "./pages/ProfessionalPage";
import VSL from "./pages/VSL";
import EspPage from "./pages/EspPage";
import Offer147Page from "./pages/Offer147Page";
import Offer147VslPage from "./pages/Offer147VslPage";
import BlackNovPage from "./pages/BlackNovPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/profissional" element={<ProfessionalPage />} />
          <Route path="/vsl" element={<VSL />} />
          <Route path="/esp" element={<EspPage />} />
          <Route path="/offer147" element={<Offer147Page />} />
          <Route path="/offer147-vsl" element={<Offer147VslPage />} />
          <Route path="/blacknov" element={<BlackNovPage />} />
          <Route path="/termos-e-politicas" element={<TermsAndPolicy />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
